import React from 'react'
import './AlbumLightbox.css';
import Close from "../../../site_media/images/icons8-close-window-24.png";
import Delete from "../../../site_media/images/trash_white.png";
import Back from "../../../site_media/images/backward.svg";
import Forward from "../../../site_media/images/forward.svg";
// import Create from "../../../site_media/images/paintbrush.png";

const Modal = ({stat, handleClose, show, requestNext, requestPrev, requestDelete }) => {
    const showHideClassName = show ? "album-focus display-block" : "album-focus display-none";

    return (
        <div className={showHideClassName}>
            <div className ="album-focus-background" >
                <section className="album-focus-main d-flex">
                    <section id = "album-focus-zones">
                        <div className="album-focus-tool-bar">
                            <img className="album-focus-close" src = {Close} alt={"X"} onClick={handleClose}/>
                            <img className="album-focus-delete" src = {Delete} alt={"--"} onClick={requestDelete}/>
                        </div>
                        <div className="album-focus-nav">
                            <img className="album-focus-next" src = {Back} alt={"<"} onClick={requestPrev}/>
                            {stat.selectedMedia}
                            <img className="album-focus-prev" src = {Forward} alt={">"} onClick={requestNext}/>
                        </div>
                    </section>
                </section>
            </div>
        </div>
    );
};



export default Modal;